import React from 'react'
import { connect } from 'react-redux'
import {getTeam} from "../../actions"
import LazyImg from '../lazyimg';
import {Helmet} from "react-helmet";

class Team extends React.Component{

    componentDidMount(){
        this.props.getTeam();
    }

    render() {
        let {data} = this.props.team;
        return (
            <div className="container">
                <div className="row">
                    {
                        data ?
                        data.map(x=> <TeamMember {...x} key={x.name + x.key} />) : null
                    }
                </div>
            </div>
        )
    }
}

export const TeamMember = ({name, profile_pic, designation}) => (
    <div className="col-md-3">
        <Helmet>
            <meta name="description" content="Meet the Ouja Team. Our team combines technical, creative & strategic talents. We live and breathe what we do and there are no difficult things for our team."/>
            <title>Team Ouja | Meet our Team | Ouja Services</title>
            <meta name="keywords" content="Team"/>
        </Helmet>
        <div className="team-member flex-center flex-column">
            <LazyImg className="team-member-image" src={profile_pic} alt={name} />
            <h3 className="team-member-name m-t-10">{name}</h3>
            <p>{designation}</p>
        </div>
    </div>
)


const mapStateToProps = ({team}) => ({
    team
})

const mapDispatchToProps = {
    getTeam
}

export default connect(mapStateToProps, mapDispatchToProps)(Team)
